import { TEST_IDS } from '@va/constants';
import { memo } from 'react';
import { DATEPICKER_WEEKDAYS } from '../utils';

export const Week = memo(() => {
  return (
    <div
      className='grid grid-cols-7 py-2 mt-0.5 border-b border-black/10 dark:border-primary-700'
      data-testid={TEST_IDS.generic.datePicker.weekDaysList}
    >
      {DATEPICKER_WEEKDAYS.map((day, index) => {
        return (
          <div
            className='text-primary-500 text-xs 2xl:text-sm tracking-wide font-medium text-center cursor-default dark:text-primary-400'
            key={index}
          >
            <span>{day?.replace(/<[^>]+>/g, '')}</span>
          </div>
        );
      })}
    </div>
  );
});
